export enum OutputSources {
    HEADPHONES = 'headphones',
    COMPUTER = 'computer'
}
